import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { QuickClientCreateForm } from '../components/QuickClientCreateForm';
import { HelpIcon } from '../components/HelpIcon';

export function QuickClientCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSuccess = (response: any) => {
    console.log('Client creation successful:', response);
    // The form handles the success display internally
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="p-6">
      <div className="w-full">
        {/* Header */}
        <div className="mb-8 text-center">
          <button
            onClick={handleCancel}
            className="inline-flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors border border-gray-300 shadow-sm mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>{t('quickCreate.form.backToDashboard')}</span>
          </button>
          
          <h1 className="text-3xl font-display font-bold text-textPrimary mb-2 flex items-center justify-center space-x-2">
            <span>{t('quickCreate.title')}</span>
            <HelpIcon 
              docPath="05-gestion-clients#05-3-creation-rapide" 
              tooltip="Documentation : Création rapide d'un client"
            />
          </h1>
          <p className="text-textSecondary">
            {t('quickCreate.subtitle')}
          </p>
        </div>

        {/* Quick Client Creation Form */}
        <QuickClientCreateForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
}